import React from "react";

export const About = () => {
  return (
    <>
      <div>
        <p>
          This is a simple to do list web app. You can use it to track your
          task.
        </p>
      </div>
    </>
  );
};
